import React, { useEffect, useState } from "react";
import "react-awesome-lightbox/build/style.css";
import { Nav, Tab, Spinner } from "react-bootstrap";

import * as _phases from "../../../CatalogPhases/operations"
import * as _reports from "../../../CatalogReports/operations"
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

/* Styles */
import "../../../../../styles/app/pages/CampaingPreview.scss";
import { Report1 } from "./Components/Report1";
import { Report2 } from "./Components/Report2";
import { Report3 } from "./Components/Report3";
import { Report4 } from "./Components/Summary"
import { Report5 } from "./Components/Report5"

export default function Report(props) {
  const [reports, setReports] = useState([])
  const [queryng, setQuery] = useState(false)
  const [activaTab, setActiveTab] = useState(null);

  useEffect(() => {
    (async () => {
      setQuery(true)
      if (props.rows.length === 0 && props.tasks.length === 0) {
        return
      }
      // const summary = {
      //   uid: "Summary",
      //   name: "Summary",
      //   tasks: [],
      //   format: "Report 4"
      // }
      const executive_summary = {
        uid: "Executive Summary",
        name: "Executive Summary",
        tasks: [],
        format: "Report 5"
      }
      const _tasks = props.tasks
      const phases_uids = [...new Set(props.campaign.phases ?? [])]
      const phases_query = await _phases.populate(phases_uids)
      const phases = phases_query.data.payload

      const reports_uids = phases.reduce((hash, phs) => [...hash, ...phs.reports], [])
      const default_reports = [...new Set(props.campaign.reports ?? [])]
      const reports_unique = [...new Set([...reports_uids, ...default_reports])]
      const reports_query = await _reports.populate(reports_unique)
      const reports = reports_query.data.payload
      const documents = []
      for (const report of [executive_summary, ...reports]) {

        const tasks = [..._tasks].filter(tsk => report.uid === report.name || report.tasks.includes(tsk.uid))
        const tasks_names = tasks.map(tsk => tsk.name)
        const _rows = props.rows.filter(row => report.uid === report.name || (tasks_names.includes(row.task) && row.product))

        const document = {
          uid: report.uid,
          name: report.name,
          format: report.format ?? "Report 4",
          tasks: tasks,
          rows: _rows
        }
        documents.push(document)
      }
      const [document] = documents
      document && setActiveTab(document.uid)
      setReports(documents)
      setQuery(false)

    })()
  }, [props.campaign, props.tasks, props.rows])
  const formats = {
    "Report 1": Report1,
    "Report 2": Report2,
    "Report 3": Report3,
    "Report 4": Report4,
    "Report 5": Report5
  }
  console.log({props: props.competition})
  return (
    <>
      <div className="card p-10 rounded-xl shadow-sm text-center" style={{ minHeight: "600px" }}>
        <h1 style={{ fontSize: "48px" }}>
          <strong>

            EXECUTIVE SUMMARY
          </strong>

        </h1>
        {queryng ? (
          <Spinner animation="border" role="status">
            <span className="sr-only">Loading...</span>
          </Spinner>
        ) : <Tab.Container activeKey={activaTab} >
          <Nav variant="buttons">
            {/* {reports.map((nav) => (
              <button
                key={nav.uid}
                className={`mx-1 btn ${activaTab === nav.uid
                  ? "btn-primary-custom"
                  : "btn-secondary"
                  }`}
                onClick={() => setActiveTab(nav.uid)}
              >
                {nav.name.toUpperCase()}
              </button>
            ))} */}
          </Nav>
          <Tab.Content unmountonexit="false">
            {
              reports.map(report => {
                const Format = formats[report.format]
                return (
                  <Tab.Pane eventKey={report.uid}>
                    <Format
                      props={report}
                      competition={props.competition}
                      campaign={props.campaign}
                      queryng={queryng} />
                  </Tab.Pane>
                )
              })
            }
          </Tab.Content>
        </Tab.Container>}
      </div>
    </>
  );
}

